import React from 'react';
import { Input } from '../../../ui';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';

export const UrlWidget = ({ widget }: { widget: PopoutWidget }) => {

    return <Flexer width="24">
        <Input before="URL:" autoFocus value={widget.value} onChange={x => widget.update({ value: x })} />
    </Flexer>;
};
